import React, { Fragment, useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import {  withRouter } from 'react-router'
import { DropzoneArea } from 'material-ui-dropzone';
import { CircularProgress, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField,RadioGroup,FormControlLabel ,Radio,FormGroup,Checkbox, Typography, Box} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {  globalPostService, globalPutService } from '../../../utils_v2/globalApiServices'
import { checkApiStatus, downloadFileType } from '../../../utils_v2';
import { templateObj } from '../';
import { globalExportService } from '../../../globalServices';
import { trackActivity } from '../../../utils/mixpanel';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import SectionCheckList from './SectionCheckList';
import { castleAirInstance } from '../../../shared_elements/components';

const syncSectionMap = {
    3: {
      title: "Airframe Documents Checklist",
      value: "",
      value_type: 1,
      reference_id: 3,
      sub_sections: []
    },
    13: {
      title: "Engine Documents Checklist",
      value: "",
      value_type: 1,
      reference_id: 13,
      sub_sections: []
    },
    14: {
      title: "Asset Loading Template",
      value: "",
      value_type: 1,
      reference_id: 14,
      sub_sections: []
    }
  };

const AddEditFormTemplate = ({params, forms, templates, getResponseBack, toggleModalFn, modal, id}) => {
    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [templateCrud, setTemplateCrud] = useState(templateObj);
    const [error, setError] = useState({});
    const [addSection,setAddSection] = useState({modal:false, data:{title:'', value:'',value_type:1,parent_section:null}})
    const [sectionData, setSectionData] = useState([]);

    const onToggleSection = (type,sectionId)=>{
        if(type){
            if(sectionId>=0){setAddSection({modal:true, data:{title:'', value:'',value_type:1, parent_section:sectionId}})
            }else{setAddSection({modal:true, data:{title:'', value:'',value_type:1,parent_section:null}})}
        }else{setAddSection({modal:false, data:{title:'', value:'',parent_section:null}})}
    }
    useEffect(() => {
        if(id){
            let template = templates.find((item) => item.id === id);
            if(template){
                setTemplateCrud(template);
                setSectionData(template?.section_data)
            }
        }
    }, []);
    const onFieldChange = (e, keyParam, value) => { setTemplateCrud({ ...templateCrud, [keyParam]: value }); }
    const onResetErrorKey = (key) => {setError({ ...error, [key]:'' })}
    const downloadSampleTemplate = () => {
        let url = '';
        if(templateCrud.type === "T003"){
            url = 'technical/v2/workorder/sample_sections_download/'
        }else if(templateCrud.type === "T004"){
            url = 'api/technical/v2/workorder/sample-observation-sections/'
        }else if(templateCrud.type === "T007"){
            url = 'technical/v2/workorder/finding-sections-sample-template/'
        }else if(templateCrud.type === "T014"){
            url = 'technical/workorder/t014/sampleT014Download'
        }else if(templateCrud.type === "T013"){
            url = 'technical/v2/workbook/sample-import-template/'
        }else{
            url = 'technical/v2/sections/sampleDownload/'
        }
        globalExportService(url)
        .then(response=>{
            downloadFileType(response, templateCrud.type +'_Sample_Template.', 'xls' );
            trackActivity('Project Management', {
                event_type: 'Item Exported',
                page_title: 'Templates',
                file_extension: 'xls',
                file_name: templateCrud?.type +'_Sample_Template'
            });
                
        })
    }
    const onAddEditTemplate = () => {
        let validationInputs = {
            name:templateCrud?.name?.trim()?.length ? '':'Please enter Name',
            file:(templateCrud?.is_section_template && castleAirInstance && templateCrud.type === "T004") || templateCrud.id || (templateCrud?.is_section_template && !castleAirInstance)? '':templateCrud.file && templateCrud.file.length ? '':'Please upload file',
            type: templateCrud.type ? '':'Please select form type',
        };
       
        if(Object.keys(validationInputs).every((k) => { return validationInputs[k] === ''})){
            let formData = new FormData();
            formData.append('name', templateCrud.name)
            formData.append('description', templateCrud.description)
            formData.append('type', templateCrud.type)
            if(templateCrud?.is_section_template && templateCrud.type === "T004"){
                formData.append('is_section_template', templateCrud.is_section_template)
                castleAirInstance && formData.append("t004_sync_form", JSON.stringify(templateCrud.t004_sync_form)) 
                if (!sectionData || sectionData.length === 0) {
                    enqueueSnackbar( 'Please add at least one Section.', { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } } );
                    return;
                }else{
                    formData.append("section_data", JSON.stringify(sectionData));
                }
            }
            if(templateCrud.file && templateCrud.type !== "T004" && castleAirInstance){ formData.append('file', templateCrud.file[0]) }
            if(templateCrud.file && !templateCrud?.is_section_template && !castleAirInstance){ formData.append('file', templateCrud.file[0]) }
            setLoading(true);
            if(templateCrud.id){
                globalPutService(`technical/templates/${templateCrud.id}/`, formData)
                .then(response => {
                    setLoading(false);
                    if(checkApiStatus(response)){
                        enqueueSnackbar(response.data.message, { variant: 'success',anchorOrigin:{horizontal:'right', vertical:'top'}});
                        toggleModalFn();
                        getResponseBack();
                        trackActivity('Project Management', {
                            event_type: 'Updated Template',
                            page_title: 'Templates',
                            request_body: formData,
                            template_id: templateCrud?.id,
                            response_msg: response?.data?.message
                        });
                    }else{
                        enqueueSnackbar(response.data.message, { variant: 'error',anchorOrigin:{horizontal:'right', vertical:'top'}})
                        trackActivity('Project Management', {
                            event_type: 'Update Template Failed!',
                            page_title: 'Templates',
                            request_body: formData,
                            template_id: templateCrud?.id,
                            response_msg: response?.data?.message
                        });
                    }
                })
            }else{
                globalPostService(`technical/templates/`, formData)
                .then(response => {
                    setLoading(false);
                    if(checkApiStatus(response)){
                        enqueueSnackbar(response.data.message, { variant: 'success',anchorOrigin:{horizontal:'right', vertical:'top'}})
                        toggleModalFn();
                        getResponseBack();
                        trackActivity('Project Management', {
                            event_type: 'Added Template',
                            page_title: 'Templates',
                            request_body: formData,
                            response_msg: response?.data?.message
                        });
                    }else{
                        enqueueSnackbar(response.data.message, { variant: 'error',anchorOrigin:{horizontal:'right', vertical:'top'}})
                        trackActivity('Project Management', {
                            event_type: 'Add Template Failed!',
                            page_title: 'Templates',
                            request_body: formData,
                            response_msg: response?.data?.message
                        });
                    }
                })
            }
        }else{
            setError(validationInputs);
        }
    }
    return(
        <Fragment>
            <Dialog
                maxWidth="lg"
                open={modal}
                onClose={toggleModalFn}
                aria-labelledby="scroll-dialog-title"
                className='project-management-modal'
                fullWidth
            >
                <DialogTitle id="scroll-dialog-title">
                        {id ? 'Edit':'Add'} Form Template
                </DialogTitle>
                <DialogContent dividers={true}>
                    <form>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    required
                                    id="name"
                                    label="Name"
                                    fullWidth
                                    margin="normal"
                                    error={error.name}
                                    helperText={error.name}
                                    value={templateCrud.name ? templateCrud.name : ''}
                                    InputLabelProps={{shrink: true}}
                                    inputProps={{maxLength: 50}}
                                    onChange={(e) => onFieldChange(e, 'name', e.target.value)}
                                    onFocus={() => onResetErrorKey('name')}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Autocomplete
                                    options = {forms.filter(i => [1,2,3,4,7,19,20].includes(i.id)) }
                                    getOptionLabel={option => option.name}
                                    id="type"
                                    value={templateCrud.type && forms.length ? forms.find(item => item.name === templateCrud.type) : null}
                                    onChange={(e, value) => onFieldChange(e, 'type', value?value.name:null)}
                                    renderInput={params => <TextField required error={error.type} helperText={error.type} onFocus={() => onResetErrorKey('type')} {...params} label="Form Type" margin="normal" fullWidth InputLabelProps={{shrink: true}} variant='outlined' />}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <TextField
                                    id="description"
                                    label="Description"
                                    fullWidth
                                    margin="normal"
                                    value={templateCrud.description ? templateCrud.description : ''}
                                    InputLabelProps={{shrink: true}}
                                    inputProps={{maxLength: 255}}
                                    onChange={(e) => onFieldChange(e, 'description', e.target.value)}
                                    variant='outlined'
                                    multiline
                                    maxRows={3}
                                />
                            </Grid>
                            {templateCrud?.type === "T004" && <>
                                {!castleAirInstance && <Grid item md={12}>
                                    <RadioGroup row name="template_summary" value={String(templateCrud?.is_section_template)} onChange={(e) =>
                                        onFieldChange(e, "is_section_template", e.target.value === "true")
                                    } >
                                        <FormControlLabel value="true" control={<Radio color="primary" size="small" />} label="Section Summary" />
                                        <FormControlLabel value="false" control={<Radio color="primary" size="small" />} label="Observation" />
                                    </RadioGroup>
                                </Grid>}
                                
                                {templateCrud?.is_section_template   && <Grid item md={12}>
                                    {castleAirInstance &&  <Box sx={{ display: "flex", alignItems: "center" }}>
                                        <Typography variant="subtitle1" style={{ fontSize: 14, letterSpacing: 0.8, textTransform: "uppercase" }} > Sync: </Typography>
                                        <FormGroup row style={{ marginLeft: "4px" }}>
                                            {[3, 13, 14].map((referenceId) => (
                                                <FormControlLabel
                                                    key={referenceId}
                                                    label={`T0${referenceId === 3 ? `0${referenceId}` : referenceId}`}
                                                    control={
                                                        <Checkbox
                                                            size="small"
                                                            color="primary"
                                                            checked={templateCrud.t004_sync_form?.includes(referenceId) || false}
                                                            onChange={(e) => {
                                                                const checked = e.target.checked;
                                                                const currentArray = templateCrud.t004_sync_form || [];
                                                                const updatedArray = checked ? [...currentArray, referenceId] : currentArray.filter((item) => item !== referenceId);
                                                                onFieldChange(e, "t004_sync_form", updatedArray);
                                                                setSectionData((prev) => {
                                                                  if (checked) {
                                                                    const exists = prev.some( (section) => section.reference_id === referenceId );
                                                                    if (exists) return prev;
                                                                    return [...prev, syncSectionMap[referenceId]];
                                                                  } else {
                                                                    return prev.filter( (section) => section.reference_id !== referenceId );
                                                                  }
                                                                });
                                                              }}
                                                        />
                                                    }
                                                />
                                            ))}
                                        </FormGroup>
                                    </Box>}
                                    <SectionCheckList params={params} onToggleSection={onToggleSection} sectionObj={addSection} sectionData={sectionData} setSectionData={setSectionData} />
                                </Grid>
                                }
                            </>}
                            {(templateCrud?.is_section_template  && castleAirInstance && templateCrud.type === "T004") || (templateCrud?.is_section_template && !castleAirInstance)  ?null:  <Grid item xs={12} md={12}>
                                <label style={{ display: 'flex', alignItems: 'center', width: '100%' }} className="for-label">Template Attachment{!templateCrud.id ? <sup>*</sup> : null}
                                    {templateCrud.type  ?
                                            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', flex: 1 }}>
                                            <span> Refer the sample template </span>
                                            <Button style={{ fontFamily: '"Conv_IBMPlexSans-Bold"', fontWeight: '700' }} size='small' color='primary' variant='text' aria-controls="simple-menu" aria-haspopup="true" onClick={downloadSampleTemplate} endIcon={<ArrowDropDownIcon fontSize='small' />}> Download </Button>
                                        </div> : null
                                    }
                                </label>
                                <div>
                                    <DropzoneArea
                                        acceptedFiles={['.xls, .xlsx']}
                                        filesLimit={1}
                                        showPreviewsInDropzone={false}
                                        maxFileSize={10428800}
                                        useChipsForPreview={true}
                                        showPreviews={ true }
                                        dropzoneText={<p>Drag & Drop Attachments Or Click Here </p>}
                                        dropzoneClass="full-w-drag-drop-zone"
                                        maxWidth="sm"
                                        alertSnackbarProps={{anchorOrigin: {vertical:'top', horizontal:'right'}}}
                                        showAlerts={['error', 'info']}
                                        onChange={(files) => {onFieldChange('', 'file', files); onResetErrorKey('file','')}}
                                    />
                                    <p><span className='attachment-note'>Format Support: .xls, .xlsx</span></p>
                                    { error.file ? <p className='error-msg'>{error.file}</p>:null}
                                </div>
                            </Grid> }
                          
                        </Grid>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button disabled={isLoading} onClick={toggleModalFn} color="primary" variant='outlined' size='small'>
                        Cancel
                    </Button>
                    <Button disabled={isLoading} onClick={() => onAddEditTemplate()} color="primary" variant='contained' size='small'>
                        {isLoading ?
                            <CircularProgress size={20} />:'Save'
                        }
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    )
}
export default withRouter(AddEditFormTemplate);
